var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOffersTruck = function SvgOffersTruck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41.76,
    height: 51.057,
    viewBox: "0 0 41.76 51.057",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_10_1",
    "data-name": "Component 10 \\u2013 1",
    transform: "translate(1.25 1.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1165",
    "data-name": "Group 1165"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M-1030.953,274.331V269.5h29.979v4.831",
    transform: "translate(1035.593 -269.5)",
    fill: "none",
    stroke: "#2699fb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M-1031.011,301.014V277.776a1.583,1.583,0,0,1,1.579-1.578h26.969a1.582,1.582,0,0,1,1.577,1.578v22.73",
    transform: "translate(1035.578 -267.763)",
    fill: "none",
    stroke: "#06016c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1184",
    "data-name": "Rectangle 1184",
    width: 34.003,
    height: 4.892,
    transform: "translate(2.692 37.22)",
    strokeWidth: 2.5,
    stroke: "#06016c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_129",
    "data-name": "Line 129",
    x2: 29.322,
    transform: "translate(4.969 13.271)",
    fill: "none",
    stroke: "#06016c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_130",
    "data-name": "Line 130",
    x2: 29.322,
    transform: "translate(4.969 24.362)",
    fill: "none",
    stroke: "#06016c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1163",
    "data-name": "Group 1163",
    transform: "translate(0 16.841)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M-1006.96,282.873h4.4v7.549h-4.4",
    transform: "translate(1041.816 -282.873)",
    fill: "none",
    stroke: "#06016c",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M-1030.234,282.873h-4.4v7.549h4.4",
    transform: "translate(1034.638 -282.873)",
    fill: "none",
    stroke: "#06016c",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_131",
    "data-name": "Line 131",
    x2: 13.958,
    transform: "translate(12.661 31.484)",
    fill: "none",
    stroke: "#2699fb",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1164",
    "data-name": "Group 1164",
    transform: "translate(6.907 42.176)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M-1023.368,302.99v4.69a1.7,1.7,0,0,1-1.691,1.691h-2.4a1.7,1.7,0,0,1-1.691-1.691v-4.69",
    transform: "translate(1029.153 -302.99)",
    fill: "none",
    stroke: "#06016c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1166",
    "data-name": "Group 1166",
    transform: "translate(27.057 42.176)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M-1007.368,302.99v4.69a1.7,1.7,0,0,1-1.691,1.691h-2.4a1.7,1.7,0,0,1-1.691-1.691v-4.69",
    transform: "translate(1013.153 -302.99)",
    fill: "none",
    stroke: "#06016c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOffersTruck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/offersTruck.414f283d.svg";
export { ForwardRef as ReactComponent };